var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { applyStyles, applyClass, any } from './utils';
import Drawer from './drawer';
var Tools = /** @class */ (function (_super) {
    __extends(Tools, _super);
    function Tools(component, mezzanine, updater) {
        var _this = _super.call(this, component, 'tools') || this;
        _this.mezzanine = mezzanine;
        _this.updater = updater;
        return _this;
    }
    Tools.prototype.isHidden = function () {
        return this.component.toolsHide && this.component.__drawers.length === 0;
    };
    Tools.prototype.isOpen = function () {
        return this.component.toolsOpen || this.component.__activeDrawerId;
    };
    Tools.prototype.getWidth = function (isMobile) {
        return this.isOpen() ? this.component.toolsWidth : this.getToggleDesktopWidth(isMobile);
    };
    Tools.prototype.getDrawerStyles = function (isMobile) {
        if (isMobile) {
            return {
                width: window.innerWidth,
                top: this.mezzanine.getVisibleHeaderHeight(),
                right: this.isOpen() ? 0 : -window.innerWidth
            };
        }
        if (this.component.__drawers.length > 0 && this.isOpen()) {
            return {
                width: this.getDrawerWidth(),
                marginRight: this.getToggleDesktopWidth(false) + 1 // 1px offset for the border
            };
        }
        return {
            width: this.component.toolsWidth,
            marginRight: this.isOpen() ? 0 : -this.component.toolsWidth + this.getToggleDesktopWidth(isMobile)
        };
    };
    Tools.prototype.getDrawerWidth = function () {
        var _a, _b, _c;
        var activeDrawerId = this.component.__getActiveDrawerId();
        return Math.min(this.updater.getDrawerMaxWidth(), (_c = (_a = this.component.resizeHandler.panelSizes[activeDrawerId], (_a !== null && _a !== void 0 ? _a : (_b = this.component.__drawers.find(function (drawer) { return drawer.id === activeDrawerId; })) === null || _b === void 0 ? void 0 : _b.defaultSize)), (_c !== null && _c !== void 0 ? _c : this.component.toolsWidth)));
    };
    Tools.prototype.update = function (isMobile) {
        return any([
            applyClass(this.drawer, 'awsui-app-layout--open', this.isOpen()),
            applyClass(this.drawer, 'awsui-app-layout__utils--hide', this.isHidden()),
            applyStyles(this.drawer, this.getDrawerStyles(isMobile))
        ]);
    };
    return Tools;
}(Drawer));
export default Tools;
//# sourceMappingURL=tools.js.map